import React, { useState } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaExternalLinkAlt, FaBuilding, FaGlobeAmericas, FaIndustry } from 'react-icons/fa';
import Hero from '../../components/Hero/Hero';
import branches from '../../data/branches';
import heroBg from '../../assets/images/gallery/warehouse/warehouse-main.jpeg';
import './Branches.css';

const tabs = [
  { key: 'headquarters', label: 'Headquarters', icon: <FaBuilding />, count: branches.headquarters.length },
  { key: 'subsidiaries', label: 'Subsidiaries', icon: <FaGlobeAmericas />, count: branches.subsidiaries.length },
  { key: 'factories', label: 'Factories', icon: <FaIndustry />, count: branches.factories.length },
];

const BranchCard = ({ branch }) => (
  <div className="branch-card">
    <div className="branch-card__header">
      <h3 className="branch-card__name">{branch.name}</h3>
      <span className="branch-card__location">{branch.location}</span>
    </div>
    <div className="branch-card__info">
      <div className="branch-card__row">
        <FaMapMarkerAlt className="branch-card__icon" />
        <span>{branch.address}</span>
      </div>
      <div className="branch-card__row">
        <FaPhoneAlt className="branch-card__icon" />
        <a href={`tel:${branch.tel}`}>{branch.tel}</a>
      </div>
    </div>
    {branch.mapUrl && (
      <a href={branch.mapUrl} target="_blank" rel="noopener noreferrer" className="branch-card__map-link">
        View on Map <FaExternalLinkAlt />
      </a>
    )}
  </div>
);

const Branches = () => {
  const [activeTab, setActiveTab] = useState('headquarters');

  return (
    <div className="branches-page">
      <Hero
        title={<>Our <span className="highlight">Branches</span></>}
        subtitle="A global network spanning 14 countries with 20+ locations — headquarters, subsidiaries, and manufacturing facilities."
        backgroundImage={heroBg}
      />

      <section className="branches section">
        <div className="container">
          <div className="branches__tabs">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`branches__tab ${activeTab === tab.key ? 'branches__tab--active' : ''}`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.icon}
                <span>{tab.label}</span>
                <span className="branches__tab-count">{tab.count}</span>
              </button>
            ))}
          </div>

          <div className="branches__grid">
            {branches[activeTab].map((branch, idx) => (
              <BranchCard key={idx} branch={branch} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Branches;
